export default class Wave {
	constructor(config) {
		// Default configuration
		this.unit = config.unit || 100;
		this.info = {
			seconds: config.infoSeconds || 0,
			time: config.infoTime || 0,
		};
		this.animationFrameRate = config.animationFrame || 1;
		this.speed = config.speed || 0.005; // New speed parameter, default 1 (normal speed)
		this.canvas = config.el || document.createElement("canvas");
		this.colorList = config.colorList || ["#EC2028", "#C1AE6A", "#00813C"];
		this.opacity = config.opacity || [0.6, 0.5, 0.3, 0.2, 0.6];
		this.zoom = config.zoom || [3, 4, 1.6, 3, 2];
		this.startPosition = config.startPosition || [
			Math.random() * 100,
			Math.random() * 100,
			Math.random() * 100,
			Math.random() * 100,
			Math.random() * 100,
		];
		this.lineWidth = config.lineWidth || 1;
		this.xAxis =
			config.xAxis || Math.floor((config.canvasHeight || 200) / 2);
		this.yAxis = config.yAxis || -1;
		this.stroke = config.stroke !== false;
		this.fill = config.fill || false;

		// Canvas setup
		this.canvas.width =
			config.canvasWidth || document.documentElement.clientWidth;
		this.canvas.height = config.canvasHeight || 200;
		this.context = this.canvas.getContext("2d");

		// Append canvas to DOM if not already attached
		if (!this.canvas.parentNode) {
			document.body.appendChild(this.canvas);
		}

		// Animation control
		this.lastTimestamp = performance.now();
		this.isRunning = false;
		this.rafId = null;

		// Start animation
		this.start();
	}

	start() {
		if (this.isRunning) return;
		this.isRunning = true;
		this.update(performance.now());
	}

	stop() {
		this.isRunning = false;
		if (this.rafId) {
			cancelAnimationFrame(this.rafId);
			this.rafId = null;
		}
	}

	update(timestamp) {
		if (!this.isRunning) return;

		// Calculate delta time for consistent animation speed
		const deltaTime = (timestamp - this.lastTimestamp) / 1000; // in seconds
		this.lastTimestamp = timestamp;

		// Update animation state with speed multiplier
		this.info.seconds +=
			this.animationFrameRate * deltaTime * 60 * this.speed;
		this.info.time = this.info.seconds * Math.PI;

		// Draw frame
		this.draw();

		// Schedule next frame
		this.rafId = requestAnimationFrame(this.update.bind(this));
	}

	draw() {
		const { context, canvas, colorList } = this;

		// Clear canvas once per frame
		context.clearRect(0, 0, canvas.width, canvas.height);

		// Draw each wave
		for (let i = 0; i < colorList.length; i++) {
			this.drawWave(
				colorList[i],
				this.opacity[i],
				this.zoom[i],
				this.startPosition[i]
			);
		}
	}

	drawWave(color, alpha, zoom, delay) {
		const { context, canvas } = this;

		context.globalAlpha = alpha;
		context.beginPath();
		this.drawSine(this.info.time / 0.5, zoom, delay);

		if (this.stroke) {
			context.strokeStyle = color;
			context.lineWidth = this.lineWidth;
			context.stroke();
		}
		if (this.fill) {
			context.lineTo(canvas.width, canvas.height);
			context.lineTo(0, canvas.height);
			context.closePath();
			context.fillStyle = color;
			context.fill();
		}
	}

	drawSine(t, zoom, delay) {
		const { context, canvas, unit, xAxis, yAxis } = this;
		const step = Math.max(2, Math.floor(canvas.width / 1000)); // Dynamic step size

		let x = t;
		let y = Math.sin(x) / zoom;
		context.moveTo(yAxis, unit * y + xAxis);

		for (let i = yAxis; i <= canvas.width + step; i += step) {
			x = t + (-yAxis + i) / unit / zoom;
			y = Math.sin(x - delay) / 3;
			context.lineTo(i, unit * y + xAxis);
		}
	}
}
